import { useQuery } from '@tanstack/react-query';
import {
    fetchRejectedScans,
    STAFF_ONLY_MESSAGE,
    type RejectedScansResponse
} from '../services/dmRejectedScans';
import { shouldRetryQuery } from '../utils/queryRetry';
import { DM_REJECTED_SCANS_KEY } from './queryKeys';

// Mount it with the modal: the list is fetched when staff open it, never with the tab.
export function useRejectedScans(patientId: string) {
    return useQuery<RejectedScansResponse>({
        queryKey: DM_REJECTED_SCANS_KEY(patientId),
        queryFn: () => fetchRejectedScans(patientId),
        retry: (failureCount, error) =>
            error.message !== STAFF_ONLY_MESSAGE && shouldRetryQuery(failureCount, error)
    });
}
